import {CSSObject, styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

const CashmereSearchBannerContainer = styled("div", {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$paddingTop: string; $copyOnly: boolean}>(({theme, $paddingTop, $copyOnly}) => {
    // Below a searchbanner we want to have a margin so there is space between the banner and products
    // when it is Copy only, mobile doesn't need the margin as when open mobile copy adds the spacing
    // when closed we do not need the extra margin as there is no banner to split up content
    const margin = $copyOnly ? {marginTop: "0", marginBottom: "0"} : {}
    return {
        paddingTop: `${$paddingTop}rem`,
        width: "100%",
        [theme.breakpoints.down("lg")]: {
            paddingTop: "0",
        },
        [theme.breakpoints.down("md")]: {
            ...margin,
        },
        margin: "0.1rem auto 1rem auto",
        maxWidth: breakpoints.values.xxl,
    } as CSSObject
})

export default CashmereSearchBannerContainer
